import { makeVar, useReactiveVar } from '@apollo/client'

export const isAuthenticatedVar = makeVar<boolean>(false)

export const initAuthState = () => {
  const token = localStorage.getItem('token')
  isAuthenticatedVar(!!token)
}

export const setAuthenticated = (isAuthenticated: boolean) => {
  isAuthenticatedVar(isAuthenticated)
}

export function useIsAuthenticated() {
  return useReactiveVar(isAuthenticatedVar)
}

export function getIsAuthenticated() {
  return isAuthenticatedVar()
}
